export default __webpack_public_path__ + "static/media/ig-likes.8445fca5.svg";